export default __webpack_public_path__ + "static/media/apolloimg.f219d509.jpeg";